import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import * as fromActions from './user-licenses.actions';
import { map, switchMap, catchError } from 'rxjs/operators';
import { zip } from 'rxjs';
import { AccountService } from '@account-users/account/services/account.service';
import { LicenseType } from '@account-users/account/models/LicenseType';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class UserLicensesEffects {
  @Effect()
  fetchAllUserLicenses$ = this.actions$.pipe(
    ofType(fromActions.UserLicensesActionTypes.LoadAllLicenses),
    switchMap(() => {
      return zip(
        this.accountService.getAllLicenses(),
        this.accountService.getLicensePermissions([
          LicenseType.Core,
          LicenseType.Tool,
        ]),
      ).pipe(
        map((result) => {
          const res = this.getLicensesAndPermissions(result);
          return new fromActions.LoadAllUserLicensesSuccess(res);
        }),
        catchError((error) => {
          this.toastr.error('Could not fetch licenses', 'Request failed');
          console.error(error);
          return [new fromActions.LoadAllUserLicensesFailed()];
        }),
      );
    }),
  );

  getLicensesAndPermissions(licencesAndPermissions: Array<object[]>) {
    const res = { licenses: [], permissions: [] };
    if (licencesAndPermissions && licencesAndPermissions.length) {
      if ('permissions' in licencesAndPermissions[0]) {
        res.permissions = licencesAndPermissions[0];
        res.licenses = licencesAndPermissions[1];
      } else {
        res.permissions = licencesAndPermissions[1];
        res.licenses = licencesAndPermissions[0];
      }
    }
    return res;
  }

  constructor(
    private actions$: Actions,
    private accountService: AccountService,
    private toastr: ToastrService,
  ) {}
}
